'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useState } from 'react'
import { useInterval } from 'ahooks'

dayjs.extend(relativeTime)

export function UDT({ dt, className }: { dt: string | any, className?: string }) {
  if (!dt) return <></>

  className = twMerge(
    'text-sm font-light flex items-center gap-x-1.5 py-1',
    className
  )

  const [fromNow, setFromNow] = useState<string | null>(dayjs(dt).fromNow())

  useInterval(() => {
    setFromNow(dayjs(dt).fromNow())
  }, 60000)

  return (
    <div className={className}>
      <span>Updated</span><span>{fromNow}</span>
    </div>
  )
}
